import React from "react";
import "./nftCardBig.scss";
import { StaticImage } from "gatsby-plugin-image";

const NftCard = () => <div className="row nft-small">
    <div className="nft-big">
        <StaticImage
                src="../images/mm2.webp"
                loading="lazy"
                width={260}
                quality={95}
                formats={["auto", "webp", "avif"]}
                alt="Marine Mogul fish"
                className="nft-big-img"
            />
            <div className="name xl">
                <div>Marine Mogul</div>
                <div className="id">#2364</div>
            </div>
            <div className="rarity l">
                <div>Epic</div>
            </div>
    </div>
    <div className="nft-big">
        <StaticImage
                src="../images/mm3.webp"
                loading="lazy"
                width={260}
                quality={95}
                formats={["auto", "webp", "avif"]}
                alt="Marine Mogul octopus"
                className="nft-big-img"
            />
            <div className="name xl">
                <div>Marine Mogul</div>
                <div className="id">#3368</div>
            </div>
            <div className="rarity l">
                <div>Rare</div>
            </div>
    </div>
    <div className="nft-big">
        <StaticImage
                src="../images/mm4.webp"
                loading="lazy"
                width={260}
                quality={95}
                formats={["auto", "webp", "avif"]}
                alt="Marine Mogul shrimp"
                className="nft-big-img"
            />
            <div className="name xl">
                <div>Marine Mogul</div>
                <div className="id">#6113</div>
            </div>
            <div className="rarity l">
                <div>Uncommon</div>
            </div>
    </div>
</div>

export default NftCard